import TextProps from "../../types/interfaces/props/TextProps";

export default function TableCell(props: TextProps) {
    return <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap text-center">
        {props.text}
    </td>
}
